export const PAYMENT_REFUND_STATUS = {
  PENDING_REFUND: 'pending_refund',
  REFUNDED: 'refunded',
};

export const PAYMENT_REFUND_STATUSES = [
  { text: 'Pending Refund', value: PAYMENT_REFUND_STATUS.PENDING_REFUND },
  { text: 'Refunded', value: PAYMENT_REFUND_STATUS.REFUNDED },
];



// WEBPACK FOOTER //
// ./src/constants/paymentRefundStatuses.js